import React from 'react';
import classNames from 'classnames';
import classes from './BackgroundLayout.scss';

export const BackgroundLayout: React.FC = () => (
    <div className={classes.container}>
        <div className={classes.case}>
            <div className={classNames(classes.radialGradient, classes.left)}>
                <div className={classes.line} />
            </div>
            <div className={classNames(classes.radialGradient, classes.right)} />
        </div>
    </div>
);
